import { CONSIGNMENT_ONBOARDING_TAB } from "@/core/helpers/consignmentOnboardingTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

// The consignment setup moved to the Onboarding page, tab by tab; what was left here
// are the contract deadlines.
export const Route = createFileRoute("/admin/consignment-setting/")({
	beforeLoad() {
		throw redirect({
			to: "/admin/consignment-onboarding",
			search: { tab: CONSIGNMENT_ONBOARDING_TAB.Contract },
			replace: true,
		});
	},
});
